import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { ExpandableList } from './ExpandableList';
import { LocaleLink } from '@common/components';
import { useAnalytics } from '@utils/analytics';
import styles from './List.module.scss';
import { getLanguagePrefix } from '@helpers';

export const List = ({ items, onClick }) => {
  const { trackInteraction } = useAnalytics();
  const { prefixLanguage: language } = useSelector(({ appState }) => appState);
  return (
    <ul className={styles.list}>
      {items.map(item => (
        <li className={styles.item} key={item.drupal_id}>
          {item.children && item.children.length > 0 ? (
            <ExpandableList
              title={item.title}
              items={item.children}
              expanded={item.expanded}
              onClick={onClick}
            />
          ) : (
            <LocaleLink
              to={
                item.title === 'Store' &&
                (item.link.uri = `/commerce/authenticate/bigcommerce`) &&
                !item.link.uri.includes('http')
                  ? window.location.origin +
                    getLanguagePrefix(language) +
                    item.link.uri.replace('internal:', '')
                  : item.link.uri.replace('internal:', '')
              }
              className={styles.link}
              onClick={() =>
                trackInteraction(
                  'side-navigation',
                  item.title,
                  item.link.uri.replace('internal:', ''),
                  'side-navigation'
                )
              }
            >
              {item.title}
            </LocaleLink>
          )}
        </li>
      ))}
    </ul>
  );
};

List.propTypes = {
  onClick: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  items: PropTypes.arrayOf(PropTypes.any),
};

List.defaultProps = {
  onClick: () => {},
};
